import { useState, useEffect } from 'react';
import axios from "axios";
var CryptoJS = require("crypto-js");
const Rijndael = require('rijndael-js');
var mcrypt = require('js-rijndael');

export async function fnGETapiResponse(APIURL, APINAME, APIBODY, APIPORT) {
    const apiRouteParamMap = {
        GETLoginCheckNew: "id",
        GETCLNYSUBTYP: "clienttype"
    };
    const routeParam = apiRouteParamMap[APINAME] || "id";
    //var BaseURL = 'http://' + APIURL + ':' + APIPORT
     var BaseURL = APIURL //'http://' + APIURL + ':' + APIPORT
    var GetDataURL = BaseURL + '/' + APINAME + ''
    let bodyContent;
    if (APIBODY.MAPINAME == "GETClientSubType") {
        if (typeof APIBODY.body === "string") {
            // For string body, use a dynamic key, e.g., 'id'
            bodyContent = { type: APIBODY.body };
        } else if (typeof APIBODY.body === "object") {
            // If already an object, keep its keys
            bodyContent = { ...APIBODY.body };
        } else {
            bodyContent = {}; // fallback
        }
    }
    if (APIBODY.MAPINAME == "getOccupation") {
        if (typeof APIBODY.body === "string") {
            // For string body, use a dynamic key, e.g., 'id'
            bodyContent = { Cmptype: APIBODY.body };
        } else if (typeof APIBODY.body === "object") {
            // If already an object, keep its keys
            bodyContent = { ...APIBODY.body };
        } else {
            bodyContent = {}; // fallback
        }
    }
    if (APIBODY.MAPINAME == "GETLoginCheckNew" || APIBODY.MAPINAME == "GETLoginCheck" || APIBODY.MAPINAME == "getrisk") {
        if (typeof APIBODY.body === "string") {
            // For string body, use a dynamic key, e.g., 'id'
            bodyContent = { id: APIBODY.body };
        } else if (APIBODY.MAPINAME == "getrisk") {
            // For string body, use a dynamic key, e.g., 'id'
            bodyContent = { id: APIBODY.body };
        } else if (typeof APIBODY.body === "object") {
            // If already an object, keep its keys
            bodyContent = { ...APIBODY.body };
        } else {
            bodyContent = {}; // fallback
        }
    }
    if (APIBODY.MAPINAME == "GETCLNYSUBTYP" || APIBODY.MAPINAME == "GETNICBRN") {
        if (typeof APIBODY.body === "string") {
            // For string body, use a dynamic key, e.g., 'id'
            bodyContent = { ClientType: APIBODY.body };
        } else if (typeof APIBODY.body === "object") {
            // If already an object, keep its keys
            bodyContent = { ...APIBODY.body };
        } else {
            bodyContent = {}; // fallback
        }
    }
    if (APIBODY.MAPINAME == "Isadmintoggleusers" || APIBODY.MAPINAME == "BatchUploadUsers" || APIBODY.MAPINAME == "ExpireCDDUsers" || APIBODY.MAPINAME == "CRMUsers" || APIBODY.MAPINAME == "ABDUsers" || APIBODY.MAPINAME == "DebtorUsers" || APIBODY.MAPINAME == "MaturityUsers" || APIBODY.MAPINAME == "ViewPolicyPendingUsers" || APIBODY.MAPINAME == "IFRS17FilesUploadUsers" || APIBODY.MAPINAME == "RbmClientusers" || APIBODY.MAPINAME == "SendSMSusers") {
        var response = await axios.get(
            GetDataURL,
            {
                params: {
                    MAPIURL: APIBODY.MAPIURL,
                    MAPINAME: APIBODY.MAPINAME,
                    MAPIPORT: APIBODY.MAPIPORT,
                    body: APIBODY.body
                }
            }
        )
        return response;
    } else {

        bodyContent = {
            ...bodyContent,          // keep old keys first
            "DBUserName": sessionStorage.getItem('username'),
            "DBPassword": "" + Fnencryption(sessionStorage.getItem('password')) + "",
            "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
            "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
            "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth')
        };
        var response = await axios.get(
            GetDataURL,
            {
                params: {
                    MAPIURL: APIBODY.MAPIURL,
                    MAPINAME: APIBODY.MAPINAME,
                    MAPIPORT: APIBODY.MAPIPORT,
                    body: JSON.stringify(bodyContent)
                }
            }
        )
        return response;
    }
};


export async function fnPostapiResponse(APIURL, APINAME, APIBODY, APIPORT) {
  
     //var BaseURL = 'http://' + APIURL + ':' + APIPORT
    var BaseURL = APIURL //'http://' + APIURL + ':' + APIPORT
    var GetDataURL = BaseURL + '/' + APINAME + ''
    if (APIBODY.MAPINAME == "PostLogin" || APIBODY.MAPINAME == "IsWindowsUser") {
        var response = await axios.post(
            GetDataURL,
            APIBODY,
            { headers: { 'Content-Type': 'application/json' } }, { timeout: 10000 })
        return response;
    } else {
        let newBody = {
            "DBUserName": sessionStorage.getItem('username'),
            "DBPassword": "" + Fnencryption(sessionStorage.getItem('password')) + "",
            "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
            "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
            "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth')
        };
        APIBODY.body = {
            ...APIBODY.body,
            ...newBody
        };
        var response = await axios.post(
            GetDataURL,
            APIBODY,
            { headers: { 'Content-Type': 'application/json' } }, { timeout: 10000 })
        return response;
    }

}

export function Fnencryption(data) {
    var key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
    var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
    return encrypted
    // Encrypt
    // var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_KEY).toString();
    // return ciphertext;
    // var hash = CryptoJS.HmacSHA256(data, "SwanAMLSearch");
    // var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    // return hashInBase64
}
//* Genrick Method to convert Excel General*//
export function fntoConvertdexceldate(excelDate) {
    var date = new Date(Math.round((excelDate - (25569)) * 86400 * 1000));
    var converted_date = date.toISOString().split('T')[0].replace("-", "").replace("-", "");
    console.log("Excel ki converted_date ye he ", converted_date);
    return converted_date
}



export function Fndecryption(data) {
    // console.log(data)
    var key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
    var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
    var bytes = CryptoJS.AES.decrypt(data, key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    return bytes;
    // Decrypt
    // var bytes  = CryptoJS.AES.decrypt(data, process.env.REACT_APP_KEY);
    // var decryptedData = bytes.toString(CryptoJS.enc.Utf8));
    // console.log(bytes)
    // "CDOMINGUE","FRAJABALLY","MDMANJUSHA","RIMRIT","DBDIDIER","CDNDVLP2","LEONG","ASEETOHUL"
}
// Isadmin toggle Users
// Isadmin toggle Users
export function Isadmintoggleusers() {
    // const Isadmintoggleusers = ["CDOMINGUE", "LBRUNBIQUE", "MADANA", "FRAJABALLY", "RIMRIT", "MDMANJUSHA", "HAHEENA", "ASEETOHUL", "CDNDVLP2", 'LEONG'];
    const Isadmintoggleusers = ["CDOMINGUE","FRAJABALLY","JOJULIEN" , "LKLUVEVESH","RKRUKHSAAR","VAVESHNA","MDMANJUSHA","RIMRIT","DBDIDIER","CDNDVLP2","LEONG","ASEETOHUL","MMMOUSHQUA"];
    return Isadmintoggleusers;
}

// Batch Upload users
export function BatchUploadUsers() {
    // const batchaccessUsers = ["FRAJABALLY", "LEONG", "ASEETOHUL", "CDNDVLP2", "MCHETTY", "CDOMINGUE", "MDMANJUSHA", "RIMRIT", "LBRUNBIQUE"];
    const batchaccessUsers = ["HMAULLOO","DCDAVEN","NMNORB","CDOMINGUE","FRAJABALLY","JOJULIEN" , "LKLUVEVESH","RKRUKHSAAR","VAVESHNA","MDMANJUSHA","RIMRIT","DBDIDIER","CDNDVLP2","LEONG","ASEETOHUL","VRVANESSA","MMMOUSHQUA"];
    return batchaccessUsers;
}
// ExpireCdd users
export function ExpireCDDUsers() {
    const expireCDDUsers = ["SAPPADU","AJASHIKA","AOANISHAH" ,'JROUSSEAU', 'ASEETOHUL', "CDNDVLP2", 'LEONG'];
    return expireCDDUsers;
}
// CRP users
export function CRMUsers() {
    const crmUsers = ["CDOMINGUE","FRAJABALLY","JOJULIEN" , "LKLUVEVESH","RKRUKHSAAR","VAVESHNA","MDMANJUSHA","RIMRIT","DBDIDIER","CDNDVLP2","LEONG","ASEETOHUL","VRVANESSA","MMMOUSHQUA"];
    return crmUsers;
}
//ABD users
export function ABDUsers() {
    const abdUsers = ["TRTIROUVEN", "PGPRISCILL", "KBISSOON", "AOANISHAH", "VMVANITA", "MPMISHTA", "AMANAIA",
        "NSNALINEE", "RLROXANNE", "KMKANCHAN", "HRHEMANTEE", 'SBSURYAVAN', "ASEETOHUL", "CDNDVLP2", 'LEONG'];
    return abdUsers;
}

//Debtors/Salesscreen users
export function DebtorUsers() {
    const debtorUsers = ["GGGRISHMA","DSEEWOOLAL", "LJEETUN", "LMONIEN", "LMOOTOOSAM", "MRUNGASAWM", "SSAWOCK", "SLUXIMON", "KNUNDOOSIN",
        "ASEETOHUL", "CDNDVLP2", 'LEONG','PHOWYAW'];
    return debtorUsers;
}
//Maturity and Installments users
export function MaturityUsers() {
    const maturityUsers = ["GGGRISHMA","DSEEWOOLAL","NNAICKEN", "LMOOTOOSAM", "SBACSOU", "NTYLOO", "DCHANGMIN", "DSDIVYB", "BPROVENCAL",
        "ASEETOHUL", "CDNDVLP2", 'LEONG','PHOWYAW'];
    return maturityUsers;
}
//ViewPolicyPendingDetails users
export function ViewPolicyPendingUsers() {
    const policyPendingUsers = ["SMALLECK","AJOOMUN", "DSDEVINA", "KHEEKWUN", "JROUSSEAU", "VCVIMLA", "ASEETOHUL", "CDNDVLP2", 'LEONG'];
    return policyPendingUsers;
}
//IFRS17FilesUploadUsers 
export function IFRS17FilesUploadUsers() {
    const IFRS17FilesUsers = ["ASEETOHUL", "CDNDVLP2", 'LEONG', 'SBSURYAVAN', 'JWONG', ' ANDCHEONG', 'NLOWING'];
    return IFRS17FilesUsers;
}
//RBM Client users (COMPLIANCE LIST)
export function RbmClientusers() {
    const RbmUsers = ["CDOMINGUE","FRAJABALLY","JOJULIEN" , "LKLUVEVESH","RKRUKHSAAR","VAVESHNA","MDMANJUSHA","RIMRIT","DBDIDIER","CDNDVLP2","LEONG","ASEETOHUL","MMMOUSHQUA"];
    return RbmUsers;
}